import { useState, useCallback } from 'react';

/**
 * Web stub implementation for expo-notifications
 * Push notifications are not supported on web in the same way as native
 */
export function useExpoPushNotifications() {
  const [pushToken, setPushToken] = useState<string | null>(null);
  const [permissionStatus, setPermissionStatus] = useState<string>('undetermined');
  const [error, setError] = useState<string | null>(null);

  const registerAsync = useCallback(async (userId: string): Promise<{ token: string | null; status: string }> => {
    console.log('[PushNotifications Web] Push notifications not fully supported on web');
    
    // Check if browser supports notifications
    if ('Notification' in window) {
      try {
        const permission = await Notification.requestPermission();
        setPermissionStatus(permission);
        
        if (permission === 'granted') {
          console.log('[PushNotifications Web] Browser notifications enabled');
          // Note: For full web push, you'd need a service worker and VAPID keys
          // This is a simplified implementation
          return { token: null, status: 'granted' };
        }
        
        return { token: null, status: permission };
      } catch (err) {
        console.warn('[PushNotifications Web] Error requesting notification permission:', err);
        setError('Failed to request notification permission');
        return { token: null, status: 'denied' };
      }
    }
    
    return { token: null, status: 'unsupported' };
  }, []);

  const unregisterAsync = useCallback(async (userId: string): Promise<void> => {
    console.log('[PushNotifications Web] Unregister not needed on web');
    setPushToken(null);
  }, []);

  return {
    registerAsync,
    unregisterAsync,
    pushToken,
    permissionStatus,
    error,
    isDevice: true, // Web is always a "device"
  };
}

export default useExpoPushNotifications;

